import { DestroyRef, inject, Injectable, signal } from '@angular/core';

import { MOBILE_MEDIA_QUERY } from '../layout/viewport.config';

/**
 * Tracks whether the viewport is below the tablet breakpoint.
 * Reuse anywhere you need to branch on mobile vs tablet/desktop layout.
 */
@Injectable({ providedIn: 'root' })
export class ViewportService {
    private readonly destroyRef = inject(DestroyRef);

    readonly isMobile = signal(this.readMatches());

    constructor() {
        if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
            return;
        }

        const mq = window.matchMedia(MOBILE_MEDIA_QUERY);
        const onChange = (event: MediaQueryListEvent): void => {
            this.isMobile.set(event.matches);
        };

        mq.addEventListener('change', onChange);
        this.destroyRef.onDestroy(() => mq.removeEventListener('change', onChange));
    }

    private readMatches(): boolean {
        if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
            return false;
        }
        return window.matchMedia(MOBILE_MEDIA_QUERY).matches;
    }
}
